import React from 'react';
import { BringzzIcon, BringzzText } from '@bringzz/components';

const ImageViewerModal = ({ isOpen, onClose, imageUrl, title }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90" onClick={onClose}>
            <div className="relative w-full h-full flex flex-col">
                {/* Header */}
                <div className="absolute top-0 left-0 right-0 z-10 flex items-center justify-between p-4 bg-gradient-to-b from-black/70 to-transparent">
                    <div className="flex items-center space-x-4">
                        <BringzzIcon
                            icon="IconClose"
                            folder="LineIcons"
                            size="24"
                            className="text-white cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={(e) => {
                                e.stopPropagation();
                                onClose();
                            }}
                        />
                        {title && (
                            <BringzzText tag="h3" className="text-white font-medium">
                                {title}
                            </BringzzText>
                        )}
                    </div>
                </div>

                {/* Image Container */}
                <div 
                    className="flex-1 flex items-center justify-center p-4"
                    onClick={(e) => e.stopPropagation()}
                >
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt={title || 'Image viewer'}
                            className="max-w-full max-h-full object-contain"
                        />
                    ) : (
                        <div className="text-center">
                            <BringzzIcon
                                icon="IconImage"
                                folder="LineIcons"
                                size="48"
                                className="text-white/50 mx-auto mb-4"
                            />
                            <BringzzText tag="h4" className="text-white/70">
                                No image available
                            </BringzzText>
                        </div>
                    )}
                </div>

                {/* Optional Footer with controls */}
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent">
                    <div className="flex justify-center space-x-4">
                        {/* <BringzzIcon
                            icon="IconDownload"
                            folder="LineIcons"
                            size="24"
                            className="text-white cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (imageUrl) {
                                    const link = document.createElement('a');
                                    link.href = imageUrl;
                                    link.download = title || 'prescription';
                                    link.click();
                                }
                            }}
                        /> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageViewerModal;